import {useCallback, useEffect} from 'react'
import { useSignal } from '@preact/signals-react'
import { getSubmit } from '@ui-seeker/utils'
import { adminIdStatusBatchList, tableBatchData, tabSelected, clearSignals } from 'Pages/Admin/GlobalExecution/@signals'
import {useToast} from "@hooks";
import useBatchBackendApiPath from "./usePath";


export default function useTable() {
	const isLoading = useSignal(false)
	const { executionStatus } = useBatchBackendApiPath()
	const { showToast } = useToast()

	const getData = useCallback(() => {
		isLoading.value = true
		getSubmit(executionStatus).then(res => {
			adminIdStatusBatchList.value = res.map(({ id_last_execution }) => id_last_execution)
			tableBatchData.value = res
			isLoading.value = false
		}).catch(() => {
			showToast.error()
			isLoading.value = false
		})
	}, [tabSelected.value])

	useEffect(() => {
		clearSignals()
		getData()
	}, [tabSelected.value])

	return {
		tableBatchData: tableBatchData.value,
		isLoading: isLoading.value,
	}

}